import axios from "axios";
import { PATH } from "../App";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to check for auth errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      // Clear the expired token from local storage and log the user out
      localStorage.removeItem("token");
      window.location.href = PATH.SIGN_IN; // Redirect the user to the login page
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
